export default __webpack_public_path__ + "static/media/sunbaewordmark.93039f33.svg";